import script from "./BotShortfallLogged.vue?vue&type=script&setup=true&lang=js"
export * from "./BotShortfallLogged.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__